export default "__VITE_ASSET__DB1GP7$R__"